export default "__VITE_ASSET__DcT5EJd8__"